<script setup>
import {ref, provide, inject} from "vue";
import needsStartupsService from "@/services/needs-startups.service";
import StartupInfo from "@/views/needs/need/StartupInfo.vue";
import {getLogo} from "@/helpers/logo";
import StartupReview from "@/views/needs/need/startupModal/StartupReview.vue";

const getWorkStatus = inject('getWorkStatus');
const getStartups = inject('getStartups');
const getActivities = inject('getActivities');
const escalated = inject('escalated');

const showModal = ref(false);
const linkId = ref(null);
const startup = ref(null);

async function getStartupInfo() {
    const {data} = await needsStartupsService.getStartupDetails(linkId.value);
    startup.value = data;
}

async function toggleStatus() {
    const {data} = await needsStartupsService.toggleStartupStatus(linkId.value);
    startup.value.status = data;
    getStartups();
    getWorkStatus();
    getActivities();
}

function open(id) {
    startup.value = null
    linkId.value = id;
    getStartupInfo();
    showModal.value = true;
}

defineExpose({
    open
});

provide('startup', startup)
provide('linkId', linkId)
</script>

<template>
    <b-modal v-model="showModal" hide-header hide-footer modal-class="modal-solution">
        <div v-if="startup" class="modal-matchmaking__wrapper">
            <a v-if="!escalated" @click="toggleStatus" class="d-block mb-4 text-center">
                <div class="button-solution">
                    <template v-if="startup.status === 'liked'">
                        Remove From Solutions
                    </template>

                    <template v-else>
                        Add To Solutions
                    </template>
                </div>
            </a>

            <div class="modal-matchmaking__content modal-matchmaking__content--expanded">
                <header class="matchmaking__content__header">
                    <div class="image-block">
                        <img :src="getLogo(startup.logo)" alt=""/>
                    </div>
                    <div>
                        <h5 class="heading5 heading5--secondary">{{ startup.name }}</h5>
                        <p v-if="startup.source === 'ai'" class="matchmaking__content__by modal-matchmaking__content__by--recommended">AI Recommended</p>

                        <p
                            v-if="startup.source === 'ecosystem'"
                            class="matchmaking__content__by modal-matchmaking__content__by--sent"
                        >
                            Sent by {{startup.ecosystem_name}}
                        </p>
                    </div>

                    <!-- <div class="vc-label">AI Recommended</div> -->

                    <button @click="showModal = false" type="button" aria-label="Close" class="close ml-auto">×</button>
                </header>

                <StartupInfo
                    v-if="startup"
                    :startup="startup"
                >
                    <template #addSection>
                        <StartupReview />
                    </template>
                </StartupInfo>
            </div>
        </div>
    </b-modal>
</template>

<style scoped>
.modal-matchmaking__content {
    position: relative !important;
}
</style>
